import { MessageService } from 'primeng/api';
import { Component, OnInit, AfterViewInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormArray, FormControl } from '@angular/forms';
import { trigger, state, style, transition, animate, animation } from '@angular/animations';
import { BarcodeFormat } from '@zxing/library';
import { BehaviorSubject } from 'rxjs';
import { ProductAuthService } from './../../services/product-auth.service';
import { LoginService } from 'src/app/services/login.service';
import { ProductAuthRequest, ProductAuthResponse, ProductRating, ProductRatingResponse, GetUserVerificationResponse, GetUserVerification, CustomFieldResponse, CustomFieldDetails } from 'src/app/models/productAuth';
import { ProductMasterResponse, ProductMaster } from '../../models/Masters/productMaster';
import { DomSanitizer } from '@angular/platform-browser';
import { UserMaster } from 'src/app/models/Masters/userMaster';

@Component({
  selector: 'app-mppkvvcl-authentication',
  templateUrl: './mppkvvcl-authentication.component.html',
  styleUrls: ['./mppkvvcl-authentication.component.css']
})
export class MPPKVVCLAuthenticationComponent implements OnInit {
  productAuthRequests: ProductAuthRequest = new ProductAuthRequest();
  user: UserMaster;
  state = 'smaller';
  moreData = true;
  feedbackForm: FormGroup;
  countriesWithPhoneCode = [
    {
    "name": "Afghanistan",
    "dial_code": "+93",
    "code": "AF"
    },
    {
    "name": "Aland Islands",
    "dial_code": "+358",
    "code": "AX"
    },
    {
    "name": "Albania",
    "dial_code": "+355",
    "code": "AL"
    },
    {
    "name": "Algeria",
    "dial_code": "+213",
    "code": "DZ"
    },
    {
    "name": "AmericanSamoa",
    "dial_code": "+1684",
    "code": "AS"
    },
    {
    "name": "Andorra",
    "dial_code": "+376",
    "code": "AD"
    },
    {
    "name": "Angola",
    "dial_code": "+244",
    "code": "AO"
    },
    {
    "name": "Anguilla",
    "dial_code": "+1264",
    "code": "AI"
    },
    {
    "name": "Antarctica",
    "dial_code": "+672",
    "code": "AQ"
    },
    {
    "name": "Antigua and Barbuda",
    "dial_code": "+1268",
    "code": "AG"
    },
    {
    "name": "Argentina",
    "dial_code": "+54",
    "code": "AR"
    },
    {
    "name": "Armenia",
    "dial_code": "+374",
    "code": "AM"
    },
    {
    "name": "Aruba",
    "dial_code": "+297",
    "code": "AW"
    },
    {
    "name": "Australia",
    "dial_code": "+61",
    "code": "AU"
    },
    {
    "name": "Austria",
    "dial_code": "+43",
    "code": "AT"
    },
    {
    "name": "Azerbaijan",
    "dial_code": "+994",
    "code": "AZ"
    },
    {
    "name": "Bahamas",
    "dial_code": "+1242",
    "code": "BS"
    },
    {
    "name": "Bahrain",
    "dial_code": "+973",
    "code": "BH"
    },
    {
    "name": "Bangladesh",
    "dial_code": "+880",
    "code": "BD"
    },
    {
    "name": "Barbados",
    "dial_code": "+1246",
    "code": "BB"
    },
    {
    "name": "Belarus",
    "dial_code": "+375",
    "code": "BY"
    },
    {
    "name": "Belgium",
    "dial_code": "+32",
    "code": "BE"
    },
    {
    "name": "Belize",
    "dial_code": "+501",
    "code": "BZ"
    },
    {
    "name": "Benin",
    "dial_code": "+229",
    "code": "BJ"
    },
    {
    "name": "Bermuda",
    "dial_code": "+1441",
    "code": "BM"
    },
    {
    "name": "Bhutan",
    "dial_code": "+975",
    "code": "BT"
    },
    {
    "name": "Bolivia, Plurinational State of",
    "dial_code": "+591",
    "code": "BO"
    },
    {
    "name": "Bosnia and Herzegovina",
    "dial_code": "+387",
    "code": "BA"
    },
    {
    "name": "Botswana",
    "dial_code": "+267",
    "code": "BW"
    },
    {
    "name": "Brazil",
    "dial_code": "+55",
    "code": "BR"
    },
    {
    "name": "British Indian Ocean Territory",
    "dial_code": "+246",
    "code": "IO"
    },
    {
    "name": "Brunei Darussalam",
    "dial_code": "+673",
    "code": "BN"
    },
    {
    "name": "Bulgaria",
    "dial_code": "+359",
    "code": "BG"
    },
    {
    "name": "Burkina Faso",
    "dial_code": "+226",
    "code": "BF"
    },
    {
    "name": "Burundi",
    "dial_code": "+257",
    "code": "BI"
    },
    {
    "name": "Cambodia",
    "dial_code": "+855",
    "code": "KH"
    },
    {
    "name": "Cameroon",
    "dial_code": "+237",
    "code": "CM"
    },
    {
    "name": "Canada",
    "dial_code": "+1",
    "code": "CA"
    },
    {
    "name": "Cape Verde",
    "dial_code": "+238",
    "code": "CV"
    },
    {
    "name": "Cayman Islands",
    "dial_code": "+ 345",
    "code": "KY"
    },
    {
    "name": "Central African Republic",
    "dial_code": "+236",
    "code": "CF"
    },
    {
    "name": "Chad",
    "dial_code": "+235",
    "code": "TD"
    },
    {
    "name": "Chile",
    "dial_code": "+56",
    "code": "CL"
    },
    {
    "name": "China",
    "dial_code": "+86",
    "code": "CN"
    },
    {
    "name": "Christmas Island",
    "dial_code": "+61",
    "code": "CX"
    },
    {
    "name": "Cocos (Keeling) Islands",
    "dial_code": "+61",
    "code": "CC"
    },
    {
    "name": "Colombia",
    "dial_code": "+57",
    "code": "CO"
    },
    {
    "name": "Comoros",
    "dial_code": "+269",
    "code": "KM"
    },
    {
    "name": "Congo",
    "dial_code": "+242",
    "code": "CG"
    },
    {
    "name": "Congo, The Democratic Republic of the Congo",
    "dial_code": "+243",
    "code": "CD"
    },
    {
    "name": "Cook Islands",
    "dial_code": "+682",
    "code": "CK"
    },
    {
    "name": "Costa Rica",
    "dial_code": "+506",
    "code": "CR"
    },
    {
    "name": "Cote d'Ivoire",
    "dial_code": "+225",
    "code": "CI"
    },
    {
    "name": "Croatia",
    "dial_code": "+385",
    "code": "HR"
    },
    {
    "name": "Cuba",
    "dial_code": "+53",
    "code": "CU"
    },
    {
    "name": "Cyprus",
    "dial_code": "+357",
    "code": "CY"
    },
    {
    "name": "Czech Republic",
    "dial_code": "+420",
    "code": "CZ"
    },
    {
    "name": "Denmark",
    "dial_code": "+45",
    "code": "DK"
    },
    {
    "name": "Djibouti",
    "dial_code": "+253",
    "code": "DJ"
    },
    {
    "name": "Dominica",
    "dial_code": "+1767",
    "code": "DM"
    },
    {
    "name": "Dominican Republic",
    "dial_code": "+1849",
    "code": "DO"
    },
    {
    "name": "Ecuador",
    "dial_code": "+593",
    "code": "EC"
    },
    {
    "name": "Egypt",
    "dial_code": "+20",
    "code": "EG"
    },
    {
    "name": "El Salvador",
    "dial_code": "+503",
    "code": "SV"
    },
    {
    "name": "Equatorial Guinea",
    "dial_code": "+240",
    "code": "GQ"
    },
    {
    "name": "Eritrea",
    "dial_code": "+291",
    "code": "ER"
    },
    {
    "name": "Estonia",
    "dial_code": "+372",
    "code": "EE"
    },
    {
    "name": "Ethiopia",
    "dial_code": "+251",
    "code": "ET"
    },
    {
    "name": "Falkland Islands (Malvinas)",
    "dial_code": "+500",
    "code": "FK"
    },
    {
    "name": "Faroe Islands",
    "dial_code": "+298",
    "code": "FO"
    },
    {
    "name": "Fiji",
    "dial_code": "+679",
    "code": "FJ"
    },
    {
    "name": "Finland",
    "dial_code": "+358",
    "code": "FI"
    },
    {
    "name": "France",
    "dial_code": "+33",
    "code": "FR"
    },
    {
    "name": "French Guiana",
    "dial_code": "+594",
    "code": "GF"
    },
    {
    "name": "French Polynesia",
    "dial_code": "+689",
    "code": "PF"
    },
    {
    "name": "Gabon",
    "dial_code": "+241",
    "code": "GA"
    },
    {
    "name": "Gambia",
    "dial_code": "+220",
    "code": "GM"
    },
    {
    "name": "Georgia",
    "dial_code": "+995",
    "code": "GE"
    },
    {
    "name": "Germany",
    "dial_code": "+49",
    "code": "DE"
    },
    {
    "name": "Ghana",
    "dial_code": "+233",
    "code": "GH"
    },
    {
    "name": "Gibraltar",
    "dial_code": "+350",
    "code": "GI"
    },
    {
    "name": "Greece",
    "dial_code": "+30",
    "code": "GR"
    },
    {
    "name": "Greenland",
    "dial_code": "+299",
    "code": "GL"
    },
    {
    "name": "Grenada",
    "dial_code": "+1473",
    "code": "GD"
    },
    {
    "name": "Guadeloupe",
    "dial_code": "+590",
    "code": "GP"
    },
    {
    "name": "Guam",
    "dial_code": "+1671",
    "code": "GU"
    },
    {
    "name": "Guatemala",
    "dial_code": "+502",
    "code": "GT"
    },
    {
    "name": "Guernsey",
    "dial_code": "+44",
    "code": "GG"
    },
    {
    "name": "Guinea",
    "dial_code": "+224",
    "code": "GN"
    },
    {
    "name": "Guinea-Bissau",
    "dial_code": "+245",
    "code": "GW"
    },
    {
    "name": "Guyana",
    "dial_code": "+595",
    "code": "GY"
    },
    {
    "name": "Haiti",
    "dial_code": "+509",
    "code": "HT"
    },
    {
    "name": "Holy See (Vatican City State)",
    "dial_code": "+379",
    "code": "VA"
    },
    {
    "name": "Honduras",
    "dial_code": "+504",
    "code": "HN"
    },
    {
    "name": "Hong Kong",
    "dial_code": "+852",
    "code": "HK"
    },
    {
    "name": "Hungary",
    "dial_code": "+36",
    "code": "HU"
    },
    {
    "name": "Iceland",
    "dial_code": "+354",
    "code": "IS"
    },
    {
    "name": "India",
    "dial_code": "+91",
    "code": "IN"
    },
    {
    "name": "Indonesia",
    "dial_code": "+62",
    "code": "ID"
    },
    {
    "name": "Iran, Islamic Republic of Persian Gulf",
    "dial_code": "+98",
    "code": "IR"
    },
    {
    "name": "Iraq",
    "dial_code": "+964",
    "code": "IQ"
    },
    {
    "name": "Ireland",
    "dial_code": "+353",
    "code": "IE"
    },
    {
    "name": "Isle of Man",
    "dial_code": "+44",
    "code": "IM"
    },
    {
    "name": "Israel",
    "dial_code": "+972",
    "code": "IL"
    },
    {
    "name": "Italy",
    "dial_code": "+39",
    "code": "IT"
    },
    {
    "name": "Jamaica",
    "dial_code": "+1876",
    "code": "JM"
    },
    {
    "name": "Japan",
    "dial_code": "+81",
    "code": "JP"
    },
    {
    "name": "Jersey",
    "dial_code": "+44",
    "code": "JE"
    },
    {
    "name": "Jordan",
    "dial_code": "+962",
    "code": "JO"
    },
    {
    "name": "Kazakhstan",
    "dial_code": "+77",
    "code": "KZ"
    },
    {
    "name": "Kenya",
    "dial_code": "+254",
    "code": "KE"
    },
    {
    "name": "Kiribati",
    "dial_code": "+686",
    "code": "KI"
    },
    {
    "name": "Korea, Democratic People's Republic of Korea",
    "dial_code": "+850",
    "code": "KP"
    },
    {
    "name": "Korea, Republic of South Korea",
    "dial_code": "+82",
    "code": "KR"
    },
    {
    "name": "Kuwait",
    "dial_code": "+965",
    "code": "KW"
    },
    {
    "name": "Kyrgyzstan",
    "dial_code": "+996",
    "code": "KG"
    },
    {
    "name": "Laos",
    "dial_code": "+856",
    "code": "LA"
    },
    {
    "name": "Latvia",
    "dial_code": "+371",
    "code": "LV"
    },
    {
    "name": "Lebanon",
    "dial_code": "+961",
    "code": "LB"
    },
    {
    "name": "Lesotho",
    "dial_code": "+266",
    "code": "LS"
    },
    {
    "name": "Liberia",
    "dial_code": "+231",
    "code": "LR"
    },
    {
    "name": "Libyan Arab Jamahiriya",
    "dial_code": "+218",
    "code": "LY"
    },
    {
    "name": "Liechtenstein",
    "dial_code": "+423",
    "code": "LI"
    },
    {
    "name": "Lithuania",
    "dial_code": "+370",
    "code": "LT"
    },
    {
    "name": "Luxembourg",
    "dial_code": "+352",
    "code": "LU"
    },
    {
    "name": "Macao",
    "dial_code": "+853",
    "code": "MO"
    },
    {
    "name": "Macedonia",
    "dial_code": "+389",
    "code": "MK"
    },
    {
    "name": "Madagascar",
    "dial_code": "+261",
    "code": "MG"
    },
    {
    "name": "Malawi",
    "dial_code": "+265",
    "code": "MW"
    },
    {
    "name": "Malaysia",
    "dial_code": "+60",
    "code": "MY"
    },
    {
    "name": "Maldives",
    "dial_code": "+960",
    "code": "MV"
    },
    {
    "name": "Mali",
    "dial_code": "+223",
    "code": "ML"
    },
    {
    "name": "Malta",
    "dial_code": "+356",
    "code": "MT"
    },
    {
    "name": "Marshall Islands",
    "dial_code": "+692",
    "code": "MH"
    },
    {
    "name": "Martinique",
    "dial_code": "+596",
    "code": "MQ"
    },
    {
    "name": "Mauritania",
    "dial_code": "+222",
    "code": "MR"
    },
    {
    "name": "Mauritius",
    "dial_code": "+230",
    "code": "MU"
    },
    {
    "name": "Mayotte",
    "dial_code": "+262",
    "code": "YT"
    },
    {
    "name": "Mexico",
    "dial_code": "+52",
    "code": "MX"
    },
    {
    "name": "Micronesia, Federated States of Micronesia",
    "dial_code": "+691",
    "code": "FM"
    },
    {
    "name": "Moldova",
    "dial_code": "+373",
    "code": "MD"
    },
    {
    "name": "Monaco",
    "dial_code": "+377",
    "code": "MC"
    },
    {
    "name": "Mongolia",
    "dial_code": "+976",
    "code": "MN"
    },
    {
    "name": "Montenegro",
    "dial_code": "+382",
    "code": "ME"
    },
    {
    "name": "Montserrat",
    "dial_code": "+1664",
    "code": "MS"
    },
    {
    "name": "Morocco",
    "dial_code": "+212",
    "code": "MA"
    },
    {
    "name": "Mozambique",
    "dial_code": "+258",
    "code": "MZ"
    },
    {
    "name": "Myanmar",
    "dial_code": "+95",
    "code": "MM"
    },
    {
    "name": "Namibia",
    "dial_code": "+264",
    "code": "NA"
    },
    {
    "name": "Nauru",
    "dial_code": "+674",
    "code": "NR"
    },
    {
    "name": "Nepal",
    "dial_code": "+977",
    "code": "NP"
    },
    {
    "name": "Netherlands",
    "dial_code": "+31",
    "code": "NL"
    },
    {
    "name": "Netherlands Antilles",
    "dial_code": "+599",
    "code": "AN"
    },
    {
    "name": "New Caledonia",
    "dial_code": "+687",
    "code": "NC"
    },
    {
    "name": "New Zealand",
    "dial_code": "+64",
    "code": "NZ"
    },
    {
    "name": "Nicaragua",
    "dial_code": "+505",
    "code": "NI"
    },
    {
    "name": "Niger",
    "dial_code": "+227",
    "code": "NE"
    },
    {
    "name": "Nigeria",
    "dial_code": "+234",
    "code": "NG"
    },
    {
    "name": "Niue",
    "dial_code": "+683",
    "code": "NU"
    },
    {
    "name": "Norfolk Island",
    "dial_code": "+672",
    "code": "NF"
    },
    {
    "name": "Northern Mariana Islands",
    "dial_code": "+1670",
    "code": "MP"
    },
    {
    "name": "Norway",
    "dial_code": "+47",
    "code": "NO"
    },
    {
    "name": "Oman",
    "dial_code": "+968",
    "code": "OM"
    },
    {
    "name": "Pakistan",
    "dial_code": "+92",
    "code": "PK"
    },
    {
    "name": "Palau",
    "dial_code": "+680",
    "code": "PW"
    },
    {
    "name": "Palestinian Territory, Occupied",
    "dial_code": "+970",
    "code": "PS"
    },
    {
    "name": "Panama",
    "dial_code": "+507",
    "code": "PA"
    },
    {
    "name": "Papua New Guinea",
    "dial_code": "+675",
    "code": "PG"
    },
    {
    "name": "Paraguay",
    "dial_code": "+595",
    "code": "PY"
    },
    {
    "name": "Peru",
    "dial_code": "+51",
    "code": "PE"
    },
    {
    "name": "Philippines",
    "dial_code": "+63",
    "code": "PH"
    },
    {
    "name": "Pitcairn",
    "dial_code": "+872",
    "code": "PN"
    },
    {
    "name": "Poland",
    "dial_code": "+48",
    "code": "PL"
    },
    {
    "name": "Portugal",
    "dial_code": "+351",
    "code": "PT"
    },
    {
    "name": "Puerto Rico",
    "dial_code": "+1939",
    "code": "PR"
    },
    {
    "name": "Qatar",
    "dial_code": "+974",
    "code": "QA"
    },
    {
    "name": "Romania",
    "dial_code": "+40",
    "code": "RO"
    },
    {
    "name": "Russia",
    "dial_code": "+7",
    "code": "RU"
    },
    {
    "name": "Rwanda",
    "dial_code": "+250",
    "code": "RW"
    },
    {
    "name": "Reunion",
    "dial_code": "+262",
    "code": "RE"
    },
    {
    "name": "Saint Barthelemy",
    "dial_code": "+590",
    "code": "BL"
    },
    {
    "name": "Saint Helena, Ascension and Tristan Da Cunha",
    "dial_code": "+290",
    "code": "SH"
    },
    {
    "name": "Saint Kitts and Nevis",
    "dial_code": "+1869",
    "code": "KN"
    },
    {
    "name": "Saint Lucia",
    "dial_code": "+1758",
    "code": "LC"
    },
    {
    "name": "Saint Martin",
    "dial_code": "+590",
    "code": "MF"
    },
    {
    "name": "Saint Pierre and Miquelon",
    "dial_code": "+508",
    "code": "PM"
    },
    {
    "name": "Saint Vincent and the Grenadines",
    "dial_code": "+1784",
    "code": "VC"
    },
    {
    "name": "Samoa",
    "dial_code": "+685",
    "code": "WS"
    },
    {
    "name": "San Marino",
    "dial_code": "+378",
    "code": "SM"
    },
    {
    "name": "Sao Tome and Principe",
    "dial_code": "+239",
    "code": "ST"
    },
    {
    "name": "Saudi Arabia",
    "dial_code": "+966",
    "code": "SA"
    },
    {
    "name": "Senegal",
    "dial_code": "+221",
    "code": "SN"
    },
    {
    "name": "Serbia",
    "dial_code": "+381",
    "code": "RS"
    },
    {
    "name": "Seychelles",
    "dial_code": "+248",
    "code": "SC"
    },
    {
    "name": "Sierra Leone",
    "dial_code": "+232",
    "code": "SL"
    },
    {
    "name": "Singapore",
    "dial_code": "+65",
    "code": "SG"
    },
    {
    "name": "Slovakia",
    "dial_code": "+421",
    "code": "SK"
    },
    {
    "name": "Slovenia",
    "dial_code": "+386",
    "code": "SI"
    },
    {
    "name": "Solomon Islands",
    "dial_code": "+677",
    "code": "SB"
    },
    {
    "name": "Somalia",
    "dial_code": "+252",
    "code": "SO"
    },
    {
    "name": "South Africa",
    "dial_code": "+27",
    "code": "ZA"
    },
    {
    "name": "South Sudan",
    "dial_code": "+211",
    "code": "SS"
    },
    {
    "name": "South Georgia and the South Sandwich Islands",
    "dial_code": "+500",
    "code": "GS"
    },
    {
    "name": "Spain",
    "dial_code": "+34",
    "code": "ES"
    },
    {
    "name": "Sri Lanka",
    "dial_code": "+94",
    "code": "LK"
    },
    {
    "name": "Sudan",
    "dial_code": "+249",
    "code": "SD"
    },
    {
    "name": "Suriname",
    "dial_code": "+597",
    "code": "SR"
    },
    {
    "name": "Svalbard and Jan Mayen",
    "dial_code": "+47",
    "code": "SJ"
    },
    {
    "name": "Swaziland",
    "dial_code": "+268",
    "code": "SZ"
    },
    {
    "name": "Sweden",
    "dial_code": "+46",
    "code": "SE"
    },
    {
    "name": "Switzerland",
    "dial_code": "+41",
    "code": "CH"
    },
    {
    "name": "Syrian Arab Republic",
    "dial_code": "+963",
    "code": "SY"
    },
    {
    "name": "Taiwan",
    "dial_code": "+886",
    "code": "TW"
    },
    {
    "name": "Tajikistan",
    "dial_code": "+992",
    "code": "TJ"
    },
    {
    "name": "Tanzania, United Republic of Tanzania",
    "dial_code": "+255",
    "code": "TZ"
    },
    {
    "name": "Thailand",
    "dial_code": "+66",
    "code": "TH"
    },
    {
    "name": "Timor-Leste",
    "dial_code": "+670",
    "code": "TL"
    },
    {
    "name": "Togo",
    "dial_code": "+228",
    "code": "TG"
    },
    {
    "name": "Tokelau",
    "dial_code": "+690",
    "code": "TK"
    },
    {
    "name": "Tonga",
    "dial_code": "+676",
    "code": "TO"
    },
    {
    "name": "Trinidad and Tobago",
    "dial_code": "+1868",
    "code": "TT"
    },
    {
    "name": "Tunisia",
    "dial_code": "+216",
    "code": "TN"
    },
    {
    "name": "Turkey",
    "dial_code": "+90",
    "code": "TR"
    },
    {
    "name": "Turkmenistan",
    "dial_code": "+993",
    "code": "TM"
    },
    {
    "name": "Turks and Caicos Islands",
    "dial_code": "+1649",
    "code": "TC"
    },
    {
    "name": "Tuvalu",
    "dial_code": "+688",
    "code": "TV"
    },
    {
    "name": "Uganda",
    "dial_code": "+256",
    "code": "UG"
    },
    {
    "name": "Ukraine",
    "dial_code": "+380",
    "code": "UA"
    },
    {
    "name": "United Arab Emirates",
    "dial_code": "+971",
    "code": "AE"
    },
    {
    "name": "United Kingdom",
    "dial_code": "+44",
    "code": "GB"
    },
    {
    "name": "United States",
    "dial_code": "+1",
    "code": "US"
    },
    {
    "name": "Uruguay",
    "dial_code": "+598",
    "code": "UY"
    },
    {
    "name": "Uzbekistan",
    "dial_code": "+998",
    "code": "UZ"
    },
    {
    "name": "Vanuatu",
    "dial_code": "+678",
    "code": "VU"
    },
    {
    "name": "Venezuela, Bolivarian Republic of Venezuela",
    "dial_code": "+58",
    "code": "VE"
    },
    {
    "name": "Vietnam",
    "dial_code": "+84",
    "code": "VN"
    },
    {
    "name": "Virgin Islands, British",
    "dial_code": "+1284",
    "code": "VG"
    },
    {
    "name": "Virgin Islands, U.S.",
    "dial_code": "+1340",
    "code": "VI"
    },
    {
    "name": "Wallis and Futuna",
    "dial_code": "+681",
    "code": "WF"
    },
    {
    "name": "Yemen",
    "dial_code": "+967",
    "code": "YE"
    },
    {
    "name": "Zambia",
    "dial_code": "+260",
    "code": "ZM"
    },
    {
    "name": "Zimbabwe",
    "dial_code": "+263",
    "code": "ZW"
    }
  ];
  ratingDisabled = false;
  recommendedItem = false;
  mobileReg: RegExp = /^[6-9]\d{9}$/;
  emailReg: RegExp = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  ratingbox = false;
  status = false;
  submitted = false;
  isModalShown: boolean;
  installMessage = false;
  scanWraper = true;
  availableDevices: MediaDeviceInfo[];
  currentDevice: MediaDeviceInfo = null;
  formatsEnabled: BarcodeFormat[] = [
    BarcodeFormat.CODE_128,
    BarcodeFormat.DATA_MATRIX,
    BarcodeFormat.EAN_13,
    BarcodeFormat.QR_CODE,
  ];
  hasDevices: boolean;
  hasPermission: boolean;
  showVerficationHistory = false;
  qrResultString: string;
  prodDetails: ProductAuthResponse = new ProductAuthResponse();
  torchEnabled = false;
  torchAvailable$ = new BehaviorSubject<boolean>(false);
  tryHarder = false;
  isAndroid = true;
  slideConfig = {
    'slidesToShow': 2, 'slidesToScroll': 1, 'infinite': true, 'dot': true,
    // "autoplay":true,
    // "autoplaySpeed":1500,
    'arrows': true,
    'centerMode': true,
    responsive: [{
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        // centerMode: true,
      }
    }, {
      breakpoint: 620,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
      }
    }]
  };
  slideConfig2 = {
    'slidesToShow': 1, 'slidesToScroll': 1, 'infinite': true, 'dot': true,
    'autoplay': true,
    'autoplaySpeed': 1500,
    'arrows': true,
    'centerMode': false,
  };
  event: any;
  askScratchList: CustomFieldDetails[] = [];
  askDetailsList: CustomFieldDetails[] = [];
  feedbackList: CustomFieldDetails[] = [];
  fakeFeedbackList: CustomFieldDetails[] = [];

  recommendedProducts: ProductMaster[] = [];
  totalRecommendedProducts: number;
  askDetailForm: FormGroup;
  mppkvvclForm: FormGroup;
  askScratchCdForm: FormGroup;
  askDetailssubmitted = false;
  mppkvvclDetailssubmitted = false;
  askScratchCdsubmitted = false;
  isAskDetailsModalShown = false;
  isMPPKVVCLDetailsModalShown = true;
  isAskScratchModalShown = false;
  isFakeFeedbackModalShown: boolean;
  fakeFeedbackForm: FormGroup;
  fakeFeedbackImage: any;
  cmpName: any;
  compId: any;
  isFakeFeedbackSubmitted: boolean;
  verificationHistory: GetUserVerification[];
  audioSrc: any;
  companyList: any[] = [];
  companyFilterList: any[] = [];
  askDetailCompanyAutofill: boolean = false;
  showratingbox() {
    this.ratingbox = !this.ratingbox;
  }

  constructor(private fb: FormBuilder, private messageService: MessageService, private loginService: LoginService,
    private prodAuthService: ProductAuthService, public sanitizer: DomSanitizer) {
    this.getCompanyList();

    this.mppkvvclForm = this.fb.group({
      email: [null, Validators.required],
      password: [null, Validators.required],
    });

    // this.feedbackForm = this.fb.group({
    //   usrName: [null, Validators.required],
    //   verificationId: [0],
    //   mobNo: [null, [Validators.required, Validators.pattern(/\(?([0-9]{3})\)?([ .-]?)([0-9]{3})\2([0-9]{4})/)]],
    //   email: [null, [Validators.required]],
    //   usrFeedback: [null, [Validators.required]]
    // });

    // this.askDetailForm = this.fb.group({
    //   cmpName: [null, Validators.required],
    //   usrName: [null, Validators.required],
    //   email: [null],
    //   mobNo: [null, Validators.required],
    // });

    //<scratch Start>

    // this.askScratchCdForm = this.fb.group({
    //   usrName: [null, Validators.required],
    //   email: [null],
    //   mobNo: [null, Validators.required],
    //   scratchCd: [null, Validators.required],
    // });

    //<scratch End>

    // this.fakeFeedbackForm = this.fb.group({

    //   usrName: [null, Validators.required],
    //   email: [null],
    //   mobNo: [null, Validators.required],
    //   verImg: [null],
    //   purchasedFrm: [null],
    //   usrFeedback: [null, Validators.required],
    // });

  }

  ngOnInit() {

    this.productAuthRequests.verificationMode = 'Web';
    this.productAuthRequests.qrData = window.location.href;
    // this.productAuthRequests.qrData = 'http://www.sureassure.com/pa?uid=R98N1*C-SkL9uyDu0o2qNA';
    this.productAuthRequests.verificationType = 2;
    this.findMe();  // find location
    this.getMobileOperatingSystem();
  }

  getCustomFieldDetails(resdata) {
    console.log("resdata", resdata)
    const companyId = resdata.data.compId != undefined ? resdata.data.compId : 0;
    this.prodAuthService.getCustomFieldDetails(companyId).subscribe((Response: CustomFieldResponse) => {
      const data = Response.details;
      console.log('data', Response.details);

      if (data && data.length > 0) {
        const askScratchList = data.filter(x => x.pageName === 'askScratchCdForm');
        if (askScratchList && askScratchList.length > 0 && askScratchList[0].fieldDetails && askScratchList[0].fieldDetails.length > 0) {
          this.askScratchList = askScratchList[0].fieldDetails.filter(x => x.isHide === false);
          console.log('this.askScratchCdForm', this.askScratchList)

          if (this.askScratchList && this.askScratchList.length > 0) {
            const formGroup = {};
            this.askScratchList.forEach(formControl => {
              formGroup[formControl.fieldName] = new FormControl('', formControl.isValidate ? Validators.required : null);
            });
            this.askScratchCdForm = new FormGroup(formGroup);
          }
        }

        const askDetailsList = data.filter(x => x.pageName === 'askDetailForm');
        if (askDetailsList && askDetailsList.length > 0 && askDetailsList[0].fieldDetails && askDetailsList[0].fieldDetails.length > 0) {
          this.askDetailsList = askDetailsList[0].fieldDetails.filter(x => x.isHide === false);
          console.log('this.askDetailsList', this.askDetailsList)
          if (this.askDetailsList && this.askDetailsList.length > 0) {
            const formGroup = {};
            this.askDetailsList.forEach(formControl => {
              formGroup[formControl.fieldName] = new FormControl('', formControl.isValidate ? Validators.required : null);
            });
            this.askDetailForm = new FormGroup(formGroup);
          }
        }

        const feedbackList = data.filter(x => x.pageName === 'feedbackForm');
        if (feedbackList && feedbackList.length > 0 && feedbackList[0].fieldDetails && feedbackList[0].fieldDetails.length > 0) {
          this.feedbackList = feedbackList[0].fieldDetails.filter(x => x.isHide === false);
          if (this.feedbackList && this.feedbackList.length > 0) {
            const formGroup = {};
            this.feedbackList.forEach(formControl => {
              formGroup[formControl.fieldName] = new FormControl('', formControl.isValidate ? Validators.required : null);
            });
            this.feedbackForm = new FormGroup(formGroup);
          }
        }

        const fakeFeedbackList = data.filter(x => x.pageName === 'fakeFeedbackForm');
        if (fakeFeedbackList && fakeFeedbackList.length > 0 && fakeFeedbackList[0].fieldDetails && fakeFeedbackList[0].fieldDetails.length > 0) {
          this.fakeFeedbackList = fakeFeedbackList[0].fieldDetails.filter(x => x.isHide === false);

          console.log('this.fakeFeedbackList', this.fakeFeedbackList)
          if (this.fakeFeedbackList && this.fakeFeedbackList.length > 0) {
            const formGroup = {};
            this.fakeFeedbackList.forEach(formControl => {
              formGroup[formControl.fieldName] = new FormControl('', formControl.isValidate ? Validators.required : null);
            });
            this.fakeFeedbackForm = new FormGroup(formGroup);
          }
        }
      }

      if (resdata.responseCode === '-3') {
        if (resdata.data.compId != "" && resdata.data.compId != undefined) {
          this.companyFilterList = this.companyList.filter(x => x.compId == resdata.data.compId);

          if (this.companyFilterList.length > 0) {
            this.askDetailForm.patchValue({
              cmpName: this.companyFilterList[0]
            });
            this.askDetailCompanyAutofill = true;
          }
        }
      }
    });
  }

  sendProductAuthData(value: any) {
    console.log(value);
    this.prodAuthService.MPPKVVCLProductAuthData(value).subscribe((productAuthResponse: ProductAuthResponse) => {
      
      if (productAuthResponse.responseCode === '118') {
        var qrcode = this.parse_query_string(window.location.href);
        window.location.href = `http://auth.secfans.in/pa?uid=${qrcode}`;
        return;
      }
      if (productAuthResponse.responseCode === '-3') {

        // if (productAuthResponse.data.compId != "" && productAuthResponse.data.compId != undefined) {
        //   this.companyFilterList = this.companyList.filter(x => x.compId = productAuthResponse.data.compId);
        //   this.askDetailForm.patchValue({
        //     cmpName: this.companyFilterList[0]
        //   });
        //   this.askDetailCompanyAutofill = true;
        // }

        this.isAskDetailsModalShown = true;
        return;
      }

      if (productAuthResponse.responseCode === '-44') {
        this.isAskScratchModalShown = true;
        return;
      }

      //this.audioSrc = this.sanitizer.bypassSecurityTrustResourceUrl(productAuthResponse.data.genuineAudio);
      this.prodDetails = productAuthResponse;
      // console.log(this.prodDetails);
      if (productAuthResponse.responseCode === '200') {
        const verificationHistories = localStorage.verificationHistories ? JSON.parse(localStorage.verificationHistories) : [];
        verificationHistories.push({ verificationId: this.prodDetails.data.verificationId, usrId: this.loginService.user() });
        localStorage.verificationHistories = JSON.stringify(verificationHistories);
        // this.prodDetails = productAuthResponse;
        // this.prodDetails = Array.of(this.prodDetails);
      } else {
        // this.messageService.add({ severity: 'error', summary: 'Oops', detail: productAuthResponse });
      }

    }, err => {

    });
  }

  ratingform(event: any) {
    const rate: ProductRating = {
      ratingId: 0,
      compId: this.prodDetails.data.compId,
      productId: this.prodDetails.data.productId,
      proRating: event.value,
      totalRatingCount: null,
      updatedBy: null,
      updatedDt: null,
      verificationId: this.prodDetails.data.verificationId
    };
    this.saveRating(rate);
  }

  getMobileOperatingSystem() {
    var userAgent = navigator.userAgent || navigator.vendor;//|| window.opera;

    // Windows Phone must come first because its UA also contains "Android"
    if (/windows phone/i.test(userAgent)) {
      return "Windows Phone";
    }

    if (/android/i.test(userAgent)) {
      return "Android";
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent)) {//&& !window.MSStream) {
      this.isAndroid = false;
      return "iOS";
    }
    if (/windows/i.test(userAgent)) {
      return "Web";
    }
    return "unknown";
  }

  saveRating(rate: ProductRating): any {
    this.prodAuthService.saveRating(rate).subscribe((resp: ProductRatingResponse) => {
      // console.log(this.prodDetails);
      if (resp.responseCode === '200') {
        this.ratingDisabled = true;
        this.prodDetails.data.productRating = resp.data.proRating;
        this.prodDetails.data.totalRating = resp.data.totalRatingCount;
      } else {
        this.messageService.add({ severity: 'error', summary: 'Oops', detail: resp.responseMessage });
      }

    }, err => {

    });
  }

  search(event) {
    let filtered: any[] = [];
    let query = event.query;
    for (let i = 0; i < this.companyList.length; i++) {
      let obj = this.companyList[i];
      if (obj.compNm.toLowerCase().indexOf(query.toLowerCase()) == 0) {
        filtered.push(obj);
      }
    }
    this.companyFilterList = filtered;
  }
  getCompanyList(): any {
    this.prodAuthService.loadCompaniesDDL().subscribe((resp: any) => {
      if (resp.responseCode === '200') {
        this.companyList = resp.details;

      } else {
        this.messageService.add({ severity: 'error', summary: 'Oops', detail: resp.responseMessage });
      }

    }, err => {

    });
  }

  // more() {
  //   this.moreData = !this.moreData;
  // }

  showModal(): void {
    this.isModalShown = true;
  }
  seeAll() {
    const obj = {
      pageSize: -1,
      compId: this.prodDetails.data.compId,
    };
    this.getLazyLoadProducts(obj);
    this.state = 'larger';
    this.recommendedItem = true;
  }
  closeBar() {
    this.installMessage = true;
  }
  hideInfo() {
    this.state = 'smaller';
    this.recommendedItem = false;
  }
  get f() {
    return this.feedbackForm.controls;
  }

  get fdetails() {
    return this.askDetailForm.controls;
  }

  get mppkvvcldetails() {
    return this.mppkvvclForm.controls;
  }

  get sdetails() {
    return this.askScratchCdForm.controls;
  }

  onSubmit() {
    this.submitted = true;

    if (this.feedbackForm.invalid) {
      return;
    }

    if (this.feedbackForm.valid) {
      const form = { ...this.feedbackForm.value };
      form.verificationId = this.prodDetails.data.verificationId;

      this.saveFeedback(form);
    }

  }

  onSubmitAskDetails() {
    this.askDetailssubmitted = true;
    if (this.askDetailForm.invalid) {
      return;
    }
    const form = { ...this.askDetailForm.value };
    this.productAuthRequests.mobNo = form.mobNo;
    this.productAuthRequests.verifiedBy = form.usrName;
    this.productAuthRequests.usrname = form.usrName;

    this.productAuthRequests.askCompId = form.cmpName.compId;
    this.productAuthRequests.compId = form.cmpName.compId;

    this.productAuthRequests.askForDetailsFilled = true;
    this.productAuthRequests.email = form.email;


    this.sendProductAuthData(this.productAuthRequests);
    this.onHiddenAskForm();
  }
  onSubmitMPPKVVCLDetails() {
    this.mppkvvclDetailssubmitted = true;
    if (this.mppkvvclForm.invalid) {
      return;
    }
    const form = { ...this.mppkvvclForm.value };
    this.productAuthRequests.verifiedBy = form.email;
    this.productAuthRequests.usrname = form.password;
    this.productAuthRequests.email = form.email;


    this.sendProductAuthData(this.productAuthRequests);
    this.onHiddenMPPKVVCLForm();
  }

  //<scratch on submit>
  onSubmitAskScratch() {

    this.askScratchCdsubmitted = true;

    if (this.askScratchCdForm.invalid) {
      return;
    }
    const form = { ...this.askScratchCdForm.value };
    this.productAuthRequests.mobNo = form.mobNo;
    this.productAuthRequests.verifiedBy = form.usrName;
    this.productAuthRequests.usrname = form.usrName;
    this.productAuthRequests.scratchCd = form.scratchCd;
    this.productAuthRequests.askForScratchFilled = true;
    //this.productAuthRequests.compId = form.cmpName.compId;
    this.productAuthRequests.email = form.email;
    this.sendProductAuthData(this.productAuthRequests);
    this.onHiddenAskScratch();

  }
  //<scratch on submit>

  saveFeedback(form: any) {
    this.prodAuthService.saveFeedback(form).subscribe((resp: ProductAuthResponse) => {
      if (resp.responseCode === '200') {
        this.messageService.add({ severity: 'success', summary: 'Success', detail: resp.responseMessage });
        this.onHidden();
      } else {
        this.messageService.add({ severity: 'error', summary: 'Oops', detail: resp.responseMessage });
      }
    }, err => {
    });
  }

  onHidden(): void {
    this.resetFeedbackForm();
    this.isModalShown = false;

  }
  handleAddRole() {

    this.showModal();
  }
  clearResult(): void {
    this.qrResultString = null;
  }

  onCamerasFound(devices: MediaDeviceInfo[]): void {
    this.availableDevices = devices;
    this.hasDevices = Boolean(devices && devices.length);
  }

  onCodeResult(resultString: string) {
    this.qrResultString = resultString;
  }

  onDeviceSelectChange(selected: string) {

    const device = this.availableDevices.find(x => x.deviceId === selected);
    this.currentDevice = device || null;
  }
  onHasPermission(has: boolean) {
    this.hasPermission = has;
  }

  onTorchCompatible(isCompatible: boolean): void {
    // this.torchAvailable$.next(isCompatible || false);
  }

  toggleTorch(): void {
    this.torchEnabled = !this.torchEnabled;
  }

  toggleTryHarder(): void {
    this.tryHarder = !this.tryHarder;
  }

  slickInit(event) { }
  breakpoint(event) { }
  afterChange(event) { }
  beforeChange(event) { }
  findMe() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        this.showPosition(position);
      }, (denied) => {
        // alert(JSON.stringify(denied));
        //this.sendProductAuthData(this.productAuthRequests);
      }, { enableHighAccuracy: true, maximumAge: 10000 });
    } else {
      //this.sendProductAuthData(this.productAuthRequests);
    }
  }
  showPosition(position) {
    this.productAuthRequests.usrlatitude = position.coords.latitude;
    this.productAuthRequests.usrlongitude = position.coords.longitude;
    this.reverseGeocodeLatLngAndVerifyProduct();
  }
  reverseGeocodeLatLngAndVerifyProduct(): any {
    // tslint:disable-next-line: max-line-length
    this.prodAuthService.reverseGeoCode(this.productAuthRequests.usrlatitude, this.productAuthRequests.usrlongitude).subscribe((response: any) => {
      this.productAuthRequests.usrAdrs = response.display_name;
      this.productAuthRequests.usrCntry = response.address.country + "(" + this.getCountryCode(response.address.country_code) + ")";
      this.productAuthRequests.usrState = response.address.state;
      this.productAuthRequests.usrZip = response.address.postcode;
      //this.sendProductAuthData(this.productAuthRequests);

    }, error => {
      // alert(JSON.stringify(error))
      //this.sendProductAuthData(this.productAuthRequests);
    });
  }


  getCountryCode(code){
    for (const item of this.countriesWithPhoneCode){
      if(item.code.toUpperCase()==code.toUpperCase())
      return item.dial_code
    }
  }
  
  getLazyLoadingValues(event: any): any {
    const obj = {
      first: event.first + 1,
      searchValue: event.globalFilter ? event.globalFilter : '',
      multiSortMeta: event.multiSortMeta,
      pageSize: event.rows,
      sortColumn: event.sortField,
      sortOrder: event.sortOrder === 1 ? 'ASC' : 'DESC',
      isActive: '%',
      compId: this.user.compId
    };
    return obj;
  }
  getLazyLoadProducts(event: any): any {
    this.prodAuthService.getAllSimilarProducts(event).subscribe((response: ProductMasterResponse) => {
      if (response.responseCode === '200') {
        this.recommendedProducts = response.details;
        this.totalRecommendedProducts = response.totalRows;
        this.recommendedProducts = this.recommendedProducts.slice();
      } else {
      }
    }, err => {
    });
  }
  rowTrackBy(index, item) {
    return item.productId;
  }
  onHiddenAskForm() {
    this.isAskDetailsModalShown = false;
  }
  onHiddenMPPKVVCLForm() {
    this.isMPPKVVCLDetailsModalShown = false;
  }

  onHiddenAskScratch() {
    this.isAskScratchModalShown = false;
  }
  onHiddenFakeFeedbackForm() {
    this.resetFakeFeedbackForm();
    this.isFakeFeedbackModalShown = false;
  }
  showFakeFeedbackForm() {
    this.isFakeFeedbackModalShown = true;
  }
  onSubmitFakeFeedback() {
    ;
    this.isFakeFeedbackSubmitted = true;
    if (this.fakeFeedbackForm.invalid) {
      return;
    }
    const formData = new FormData();
    formData.append('verificationId', this.prodDetails.data.verificationId);
    formData.append('verImg', this.fakeFeedbackImage);
    formData.append('email', this.fakeFeedbackForm.value.email);
    formData.append('mobNo', this.fakeFeedbackForm.value.mobNo);
    formData.append('usrName', this.fakeFeedbackForm.value.usrName);

    formData.append('cmpName', this.fakeFeedbackForm.value.cmpName);

    formData.append('purchasedFrm', this.fakeFeedbackForm.value.purchasedFrm);
    formData.append('usrFeedback', this.fakeFeedbackForm.value.usrFeedback);
    this.feedBackOnFakeVerification(formData);
  }
  feedBackOnFakeVerification(formData: FormData) {
    this.prodAuthService.feedBackOnFakeVerification(formData).subscribe((resp: ProductAuthResponse) => {
      if (resp.responseCode === '200') {
        this.messageService.add({ severity: 'success', summary: 'Success', detail: resp.responseMessage });
        this.fakeFeedbackForm.reset();
        this.onHiddenFakeFeedbackForm();
      } else {
        this.messageService.add({ severity: 'error', summary: 'Oops', detail: resp.responseMessage });
      }
    }, err => {
    });
  }
  get fakeForm() {
    return this.fakeFeedbackForm.controls;
  }
  handleFakeFeedImage(event) {
    if (event) {
      if (event.files) {


        if (event.files.length > 0) {

          this.fakeFeedbackForm.controls['verImg'].clearValidators();
          this.fakeFeedbackForm.controls['verImg'].setErrors(null);
          this.fakeFeedbackForm.controls['verImg'].setValidators(null);

          this.fakeFeedbackForm.value.verImg = event.files[0];
          this.fakeFeedbackImage = event.files[0];
        }
      }
    }
  }
  resetFeedbackForm() {
    this.feedbackForm.reset();
    const obj = this.f;
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        obj[key].setErrors(null);
      }
    }
    this.submitted = false;
  }
  resetFakeFeedbackForm() {
    this.fakeFeedbackForm.reset();
    const obj = this.fakeForm;
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        obj[key].setErrors(null);
      }
    }
    this.isFakeFeedbackSubmitted = false;
  }
  hideVerificationHistory() {
    this.showVerficationHistory = false;
  }
  handleScanHistory() {
    const verificationHistories = localStorage.verificationHistories ? JSON.parse(localStorage.verificationHistories) : [];
    if (verificationHistories.length > 0) {
      const req = { first: 0, pageNo: 0, pageSize: -1, verificationHistories };
      this.getVerificationHistory(req);
    }
    this.showVerficationHistory = true;
  }
  getVerificationHistory(verificationHistories: any) {
    this.prodAuthService.getVerificationHistory(verificationHistories).subscribe((resp: GetUserVerificationResponse) => {
      if (resp.responseCode === '200') {
        this.verificationHistory = resp.data;
      } else {
      }
    }, err => {
    });
  }

  omit_special_char(event) {
    var k;
    k = event.charCode;  // k = event.keyCode;  (Both can be used)
    return ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57));
  }

  parse_query_string(url_string) {
    var url = new URL(url_string);
    var c = url.searchParams.get("uid");
    console.log(c);
    return c;
  }
}